import { render, staticRenderFns } from "./ShortListLoader.vue?vue&type=template&id=0ed5eb28&"
import script from "./ShortListLoader.vue?vue&type=script&lang=js&"
export * from "./ShortListLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports